import React from 'react';
import Rotate from '../../assets/images/rotate.svg';
import './rotate.scss';

const RotateContainer = () => (
    <div className="flexbox-fill rotate-container">
        <div className="container p-0">
            <div className="message-container">
                <div className="rotate-title">Welcome to musico</div>
                <img src={Rotate} alt="rotate" />
                <div className="rotate-message">Rotate Your Device to start</div>
            </div>
        </div>
    </div>
);

export default RotateContainer;
